<template>
  <el-container>
    <el-header>
      <WebHeader/>
    </el-header>

    <el-main>
      <router-view/>
    </el-main>

<!--    <el-footer>-->
<!--      <WebFooter/>-->
<!--    </el-footer>-->
  </el-container>
</template>

<script>

import WebHeader from "@/components/WebHeader";
import WebFooter from "@/components/WebFooter";

export default {
  name: 'App',
  components: {
    WebFooter,
    WebHeader
  }
}
</script>

<style>
.el-header, .el-footer {
  background-color: white;
  color: #333;
  height: 100px !important;
  text-align: center;
  /*line-height: 60px;*/
  line-height: 100px;
}

.el-footer {
  padding: 0;
}
.el-container {
  height: 99%;
  width: 100%;
}

.el-main {
  background-color: white;
  color: #333;
  margin: 0;
  padding: 0;
  /*text-align: center;*/
  /*line-height: 160px;*/
}

</style>
